import { useSelector } from 'react-redux'

import { selectAggregateDepotsByLatLng } from '@/features/domain/depot'

export function useDepotsAsMap() {
  return useSelector(selectAggregateDepotsByLatLng)
}
